var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 224,
    viewBox: "0 0 446 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddd_134_4451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 38.1584,
    width: 308,
    height: 85.8736,
    rx: 17.1747,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.8587,
    y: 39.0172,
    width: 306.283,
    height: 84.1561,
    rx: 16.316,
    stroke: "url(#paint0_linear_134_4451)",
    strokeWidth: 1.71747
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.372,
    cy: 81.0952,
    r: 25.7621,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.743,
    y: 63.9205,
    width: 194.647,
    height: 12.5948,
    rx: 4.57993,
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.743,
    y: 85.6752,
    width: 194.647,
    height: 12.5948,
    rx: 4.57993,
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.9149,
    y: 65.6379,
    width: 30.9145,
    height: 30.9145,
    rx: 15.4572,
    fill: "#005EB8",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.652 81.7968L112.093 88.2374L124.974 75.3563",
    stroke: "#005EB8",
    strokeWidth: 2.57621,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddd_134_4451",
    x: 0.301117,
    y: 0.374062,
    width: 445.398,
    height: 223.271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.06188
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17987
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0155009 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_134_4451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.68557
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.98397
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0221855 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_134_4451",
    result: "effect2_dropShadow_134_4451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.47832
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.08702
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0278145 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_134_4451",
    result: "effect3_dropShadow_134_4451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.2843
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5381
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0344991 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_134_4451",
    result: "effect4_dropShadow_134_4451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 30.9145
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.3494
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_134_4451",
    result: "effect5_dropShadow_134_4451"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_134_4451",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_134_4451",
    x1: 223,
    y1: 38.1584,
    x2: 223,
    y2: 124.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B15906"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentCard2);
export default __webpack_public_path__ + "static/media/AssessmentCard2.32b51681f1f59470f1abcfbbc81eb299.svg";
export { ForwardRef as ReactComponent };